/*
*
* File JS componente Sticky CTA
*
*/

 
// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './index.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const stickyCta = () => {
    const cta = document.querySelector('.sticky-cta');
    
    if(!cta) return;

    window.addEventListener('scroll', function() {    
        const scrollPosition = window.scrollY + window.innerHeight    // Posizione attuale dello scroll
        const documentHeight = document.documentElement.scrollHeight; // Altezza totale del documento
              
        if (documentHeight - scrollPosition <= 100) {
          cta.classList.add('hidden');
        } else {
          cta.classList.remove('hidden');
        }
    });
}

var _default = stickyCta;

if (typeof window !== 'undefined' && typeof _default !== 'undefined') {
  window.__imComponents = window.__imComponents || {};
  window.__imComponents["sticky-cta"] = _default;
}

export default stickyCta;

//--------------------------------------------------------------------//